import type { ChipProps } from '@mui/material';
import { Chip } from '@mui/material';
import { tss } from 'tss-react/mui';

export type Or2ChipProps = ChipProps;

const useStyles = tss.create(({ theme }) => ({
  chipLabel: {
    // Aligns chip label with delete button
    paddingTop: theme.spacing(0.2625),
  },
}));

export const Or2Chip = (props: ChipProps) => {
  const { classes } = useStyles();
  const { classes: propsClasses } = props;

  return (
    <Chip {...props} classes={{ label: classes.chipLabel, ...propsClasses }} />
  );
};
